const channels = [
  {
    icon: "ri-mail-line",
    title: "反馈邮箱",
    value: "support@papayamanga.example.com",
    desc: "作品信息勘误、更新数据反馈，24 小时内回复。",
  },
  {
    icon: "ri-message-3-line",
    title: "读者社群",
    value: "公众号：番木瓜漫画",
    desc: "追更提醒、榜单速递、活动福利第一时间送达。",
  },
  {
    icon: "ri-edit-line",
    title: "作者投稿",
    value: "author@papayamanga.example.com",
    desc: "国漫创作者合作与连载投稿，期待你的作品。",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="overflow-hidden rounded-2xl bg-primary-900">
        <div className="grid grid-cols-1 gap-8 p-8 md:p-12 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="font-heading text-2xl text-background-50 md:text-4xl">
              想追的漫画，一个都不错过
            </h2>
            <p className="mt-3 text-background-100/90">
              无论是反馈作品信息，还是投稿你的连载新作，都可以通过下面的方式找到我们。番木瓜漫画愿和你一起，把好看的故事追到底。
            </p>
            <a
              href="#serial"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 font-medium text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-fire-line"></i>
              立即开始追更
            </a>
          </div>
          <div className="grid grid-cols-1 gap-4">
            {channels.map((c) => (
              <div
                key={c.title}
                className="flex items-start gap-4 rounded-lg bg-background-50/10 p-4 ring-1 ring-background-50/15"
              >
                <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`${c.icon} text-lg`}></i>
                </span>
                <div className="min-w-0">
                  <h3 className="font-medium text-background-50">{c.title}</h3>
                  <p className="mt-0.5 text-sm text-accent-300">{c.value}</p>
                  <p className="mt-1 text-xs text-background-100/80">{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}